export const componentPaths = {
  "cadastro.estado": () =>
    import("@/components/locais/estados/CadastroEstado.vue"),
  clientes: () =>
    import("@/components/comercial/clientes/ListagemClientes.vue"),
  "cadastro.Cliente": () =>
    import("@/components/comercial/clientes/CadastroCliente.vue"),
  "editar.cliente": () =>
    import("@/components/comercial/clientes/EditarCliente.vue"),
  ClienteEnderecoClassificacoes: () =>
    import(
      "@/components/comercial/cliente-endereco-classificacao/ListagemClienteEnderecoClassificacao"
    ),
  "cadastro.ClienteEnderecoClassificacao": () =>
    import(
      "@/components/comercial/cliente-endereco-classificacao/CadastroClienteEnderecoClassificacao"
    ),
  "editar.clienteenderecoclassificacao": () =>
    import(
      "@/components/comercial/cliente-endereco-classificacao/EditarClienteEnderecoClassificacao"
    ),
  Usuário: () => import("@/components/acessos/Usuarios/PerfilUsuario"),
  "cadastro.Usuario": () =>
    import("@/components/acessos/Usuarios/CadastroUsuario"),
  Usuarios: () => import("@/components/acessos/Usuarios/ListagemUsuarios"),
  "editar.usuario": () => import("@/components/acessos/Usuarios/EditarUsuario"),
  Pedidos: () => import("@/components/operacoes/pedidos/ListagemPedidos"),
  "cadastro.Pedido": () =>
    import("@/components/operacoes/pedidos/CadastroPedido.vue"),
  "editar.pedido": () => import("@/components/operacoes/pedidos/EditarPedido"),
  Inquilinos: () =>
    import("@/components/software/inquilinos/ListagemInquilinos"),
  "cadastro.Inquilino": () =>
    import("@/components/software/inquilinos/CadastroInquilino"),
  "editar.inquilino": () =>
    import("@/components/software/inquilinos/EditarInquilino"),
  "configuracoes.inquilino": () =>
    import("@/components/software/inquilinos/ConfiguracoesInquilino.vue"),
  CertificadosA1: () =>
    import("@/components/software/certificados-a1/ListagemCertificadosA1.vue"),
  "cadastro.CertificadoA1": () =>
    import("@/components/software/certificados-a1/CadastroCertificadoA1.vue"),
  "editar.certificadoa1": () =>
    import("@/components/software/certificados-a1/EditarCertificadoA1.vue"),
  FuncionarioSindicatos: () =>
    import(
      "@/components/pessoal/funcionario-sindicato/ListagemFuncionarioSindicatos"
    ),
  "cadastro.FuncionarioSindicato": () =>
    import(
      "@/components/pessoal/funcionario-sindicato/CadastroFuncionarioSindicato"
    ),
  "editar.funcionariosindicato": () =>
    import(
      "@/components/pessoal/funcionario-sindicato/EditarFuncionarioSindicato"
    ),
  FuncionarioAfastamentoTipos: () =>
    import(
      "@/components/pessoal/funcionario-afastamento-tipo/ListagemFuncionarioAfastamentoTipos"
    ),
  "cadastro.FuncionarioAfastamentoTipo": () =>
    import(
      "@/components/pessoal/funcionario-afastamento-tipo/CadastroFuncionarioAfastamentoTipo"
    ),
  "editar.funcionarioafastamentotipo": () =>
    import(
      "@/components/pessoal/funcionario-afastamento-tipo/EditarFuncionarioAfastamentoTipo"
    ),
  FuncionarioCargos: () =>
    import("@/components/pessoal/funcionario-cargo/ListagemFuncionarioCargos"),
  "cadastro.FuncionarioCargo": () =>
    import("@/components/pessoal/funcionario-cargo/CadastroFuncionarioCargo"),
  "editar.funcionariocargo": () =>
    import("@/components/pessoal/funcionario-cargo/EditarFuncionarioCargo"),
  Medicos: () => import("@/components/pessoal/medicos/ListagemMedicos"),
  "cadastro.Medico": () =>
    import("@/components/pessoal/medicos/CadastroMedico"),
  "editar.medico": () => import("@/components/pessoal/medicos/EditarMedico"),
  SupportTeamMembers: () =>
    import(
      "@/components/support/support-team-member/ListagemSupportTeamMembers"
    ),
  SupportSubjects: () =>
    import("@/components/support/support-subject/ListagemSupportSubjects"),
  TutorialProcessos: () =>
    import("@/components/tutorials/TutorialProcessos.vue"),
  "cadastro.SupportTeamMember": () =>
    import(
      "@/components/support/support-team-member/CadastroSupportTeamMember"
    ),
  "editar.supportteammember": () =>
    import("@/components/support/support-team-member/EditarSupportTeamMember"),
  "cadastro.SupportSubject": () =>
    import("@/components/support/support-subject/CadastroSupportSubject"),
  "editar.supportsubject": () =>
    import("@/components/support/support-subject/EditarSupportSubject"),
  FuncionarioFolhaPagamentoVerbas: () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento-verba/ListagemFuncionarioFolhaPagamentoVerba"
    ),
  "cadastro.FuncionarioFolhaPagamentoVerba": () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento-verba/CadastroFuncionarioFolhaPagamentoVerba"
    ),
  "editar.funcionariofolhapagamentoverba": () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento-verba/EditarFuncionarioFolhaPagamentoVerba"
    ),
  Funcionarios: () =>
    import("@/components/pessoal/funcionarios/ListagemFuncionarios"),
  FuncionarioContratacoesDesligamentosPeriodo: () =>
    import(
      "@/components/pessoal/funcionarios/ListagemFuncionarioContratacoesDesligamentosPeriodo.vue"
    ),
  RotatividadeAdmissionalDemissional: () =>
    import(
      "@/components/pessoal/funcionarios/DashboardRotatividadeAdmissionalDemissional.vue"
    ),
  IntegracaoExternaHistorico: () =>
    import(
      "@/components/software/integracoes-externas/ListagemIntegracaoExterna.vue"
    ),
  FuncionarioIntegracaoExterna: () =>
    import(
      "@/components/pessoal/funcionarios/ListagemFuncionarioIntegracaoExterna.vue"
    ),
  "cadastro.Funcionario": () =>
    import("@/components/pessoal/funcionarios/CadastroFuncionario.vue"),
  "cadastro.FuncionarioResumed": () =>
    import(
      "@/components/pessoal/funcionarios-resume/CadastroFuncionarioResume.vue"
    ),
  "editar.funcionario": () =>
    import("@/components/pessoal/funcionarios/EditarFuncionario"),
  FuncionarioPontos: () =>
    import("@/components/pessoal/funcionario-ponto/ListagemFuncionarioPontos"),
  DashboardFuncionarioPonto: () =>
    import(
      "@/components/pessoal/funcionario-ponto/graficos/registro-ponto/DashboardFuncionarioPonto.vue"
    ),
  DashboardCercaPerimetroFuncionarioPonto: () =>
    import(
      "@/components/pessoal/funcionario-ponto/graficos/registro-ponto/DashboardCercaPerimetroFuncionarioPonto.vue"
    ),
  "cadastro.FuncionarioPonto": () =>
    import("@/components/pessoal/funcionario-ponto/CadastroFuncionarioPonto"),
  "editar.funcionarioponto": () =>
    import("@/components/pessoal/funcionario-ponto/EditarFuncionarioPonto"),
  Paises: () => import("@/components/locais/paises/ListagemPaises"),
  "cadastro.Pais": () => import("@/components/locais/paises/CadastroPais"),
  "editar.pais": () => import("@/components/locais/paises/EditarPais"),
  Pessoas: () => import("@/components/pessoal/pessoas/ListagemPessoas.vue"),
  "cadastro.Pessoa": () =>
    import("@/components/pessoal/pessoas/CadastroPessoa.vue"),
  "editar.pessoa": () =>
    import("@/components/pessoal/pessoas/EditarPessoa.vue"),
  Estados: () => import("@/components/locais/estados/ListagemEstados.vue"),
  "cadastro.Estado": () =>
    import("@/components/locais/estados/CadastroEstado.vue"),
  "editar.estado": () => import("@/components/locais/estados/EditarEstado.vue"),
  Cidades: () => import("@/components/locais/cidades/ListagemCidades.vue"),
  "cadastro.Cidade": () =>
    import("@/components/locais/cidades/CadastroCidade.vue"),
  "editar.cidade": () => import("@/components/locais/cidades/EditarCidade.vue"),
  Veiculos: () =>
    import("@/components/operacoes/veiculos/ListagemVeiculos.vue"),
  "cadastro.Veiculo": () =>
    import("@/components/operacoes/veiculos/CadastroVeiculo.vue"),
  "editar.veiculo": () =>
    import("@/components/operacoes/veiculos/EditarVeiculo.vue"),
  VeiculoModelos: () =>
    import("@/components/operacoes/veiculo-modelos/ListagemVeiculoModelos.vue"),
  "cadastro.VeiculoModelo": () =>
    import("@/components/operacoes/veiculo-modelos/CadastroVeiculoModelo.vue"),
  "editar.veiculomodelo": () =>
    import("@/components/operacoes/veiculo-modelos/EditarVeiculoModelo.vue"),
  Roteiros: () =>
    import("@/components/operacoes/roteiros/ListagemRoteiros.vue"),
  "cadastro.Roteiro": () =>
    import("@/components/operacoes/roteiros/CadastroRoteiro.vue"),
  "editar.roteiro": () =>
    import("@/components/operacoes/roteiros/EditarRoteiro.vue"),
  RoteiroModelos: () =>
    import("@/components/operacoes/roteiroModelos/ListagemRoteiroModelo.vue"),
  "cadastro.RoteiroModelo": () =>
    import("@/components/operacoes/roteiroModelos/CadastroRoteiroModelo.vue"),
  "editar.roteiromodelo": () =>
    import("@/components/operacoes/roteiroModelos/EditarRoteiroModelo.vue"),
  GuiaTransporte: () =>
    import("@/components/operacoes/guiaTransporte/ListagemGuiaTransporte.vue"),
  "editar.guiatransporte": () =>
    import("@/components/operacoes/guiaTransporte/EditarGuiaTransporte.vue"),
  Suprimentos: () => import("@/components/operacoes/tesouraria/Suprimento.vue"),
  "cadastro.Suprimento": () =>
    import("@/components/operacoes/tesouraria/CadastroSuprimento.vue"),
  "editar.suprimento": () =>
    import("@/components/operacoes/tesouraria/EditarSuprimento.vue"),
  Questionarios: () =>
    import("@/components/operacoes/questionarios/ListagemQuestionarios.vue"),
  "cadastro.Questionario": () =>
    import("@/components/operacoes/questionarios/CadastroQuestionario.vue"),
  "editar.questionario": () =>
    import("@/components/operacoes/questionarios/EditarQuestionario.vue"),
  PostoTrabalhoSupervisoes: () =>
    import(
      "@/components/operacoes/posto-trabalho-supervisao/ListagemPostoTrabalhoSupervisao.vue"
    ),
  "cadastro.PostoTrabalhoRondaLocal": () =>
    import(
      "@/components/operacoes/posto-trabalho-ronda/CadastroPostoTrabalhoRondaLocal.vue"
    ),
  "editar.postotrabalhorondalocal": () =>
    import(
      "@/components/operacoes/posto-trabalho-ronda/EditarPostoTrabalhoRondaLocal.vue"
    ),
  "cadastro.PostoTrabalhoRondaPlanejamento": () =>
    import(
      "@/components/operacoes/posto-trabalho-ronda/CadastroPostoTrabalhoRondaPlanejamento.vue"
    ),
  "editar.postotrabalhorondaplanejamento": () =>
    import(
      "@/components/operacoes/posto-trabalho-ronda/EditarPostoTrabalhoRondaPlanejamento.vue"
    ),
  "editar.postotrabalhorondaexecucao": () =>
    import(
      "@/components/operacoes/posto-trabalho-ronda/EditarPostoTrabalhoRondaExecucao.vue"
    ),
  Nr1Topicos: () =>
    import("@/components/pessoal/nr1/nr1-topicos/ListagemNr1Topicos.vue"),
  "cadastro.Nr1Topico": () =>
    import("@/components/pessoal/nr1/nr1-topicos/CadastroNr1Topico.vue"),
  "editar.nr1topico": () =>
    import("@/components/pessoal/nr1/nr1-topicos/EditarNr1Topico.vue"),
  Nr1Campanhas: () =>
    import("@/components/pessoal/nr1/nr1-campanhas/ListagemNr1Campanhas.vue"),
  "cadastro.Nr1Campanha": () =>
    import("@/components/pessoal/nr1/nr1-campanhas/CadastroNr1Campanha.vue"),
  "editar.nr1campanha": () =>
    import("@/components/pessoal/nr1/nr1-campanhas/EditarNr1Campanha.vue"),
  "editar.roteirotrajeto": () =>
    import("@/components/operacoes/roteiroTrajeto/EditarRoteiroTrajeto.vue"),
  "cadastro.RoteiroTrajeto": () =>
    import("@/components/operacoes/roteiroTrajeto/CadastroRoteiroTrajeto.vue"),
  Produtos: () => import("@/components/recursos/produtos/ListagemProdutos.vue"),
  Inventario: () => import("@/components/recursos/inventario/Inventario.vue"),
  "cadastro.Produto": () =>
    import("@/components/recursos/produtos/CadastroProduto.vue"),
  "editar.produto": () =>
    import("@/components/recursos/produtos/EditarProduto.vue"),
  ProdutoCategorias: () =>
    import(
      "@/components/recursos/produto-categorias/ListagemProdutoCategorias.vue"
    ),
  "cadastro.produtoCategoria": () =>
    import(
      "@/components/recursos/produto-categorias/CadastroProdutoCategoria.vue"
    ),
  "editar.produtoCategoria": () =>
    import(
      "@/components/recursos/produto-categorias/EditarProdutoCategoria.vue"
    ),
  ContaBancarias: () =>
    import(
      "@/components/financeiro/conta-bancarias/ListagemContaBancarias.vue"
    ),
  "cadastro.ContaBancaria": () =>
    import("@/components/financeiro/conta-bancarias/CadastroContaBancaria.vue"),
  "editar.contabancaria": () =>
    import("@/components/financeiro/conta-bancarias/EditarContaBancaria.vue"),
  "extrato.contabancaria": () =>
    import("@/components/financeiro/conta-bancarias/Extrato.vue"),
  fluxoDiario: () => import("@/components/financeiro/analises/FluxoDiario.vue"),
  "dfc.direto": () => import("@/components/financeiro/analises/dfc/DFC.vue"),
  analiseCC: () =>
    import("@/components/financeiro/analises/analiseCC/Analise.vue"),
  DRE: () => import("@/components/financeiro/analises/dre/DRE.vue"),
  CentroCustos: () =>
    import("@/components/financeiro/centro-custos/ListagemCentroCustos.vue"),
  CentroCustosAnalitico: () =>
    import(
      "@/components/financeiro/centro-custos/ListagemCentroCustosAnalitico.vue"
    ),
  CentroCustoNiveis: () =>
    import(
      "@/components/financeiro/centro-custo-nivel/ListagemCentroCustoNivel.vue"
    ),
  "cadastro.CentroCusto": () =>
    import("@/components/financeiro/centro-custos/CadastroCentroCusto.vue"),
  "editar.centrocusto": () =>
    import("@/components/financeiro/centro-custos/EditarCentroCusto.vue"),
  RateioCentroCustoPadroes: () =>
    import(
      "@/components/financeiro/rateio-centro-custo-padrao/ListagemRateioCentroCustoPadroes.vue"
    ),
  "cadastro.RateioCentroCustoPadrao": () =>
    import(
      "@/components/financeiro/rateio-centro-custo-padrao/CadastroRateioCentroCustoPadrao.vue"
    ),
  "editar.rateiocentrocustopadrao": () =>
    import(
      "@/components/financeiro/rateio-centro-custo-padrao/EditarRateioCentroCustoPadrao.vue"
    ),
  "cadastro.CentroCustoNivel": () =>
    import(
      "@/components/financeiro/centro-custo-nivel/CadastroCentroCustoNivel.vue"
    ),
  "editar.centrocustonivel": () =>
    import(
      "@/components/financeiro/centro-custo-nivel/EditarCentroCustoNivel.vue"
    ),
  OrcamentoAnual: () =>
    import(
      "@/components/financeiro/orcamento-anual/ListagemOrcamentoAnual.vue"
    ),
  "cadastro.OrcamentoAnual": () =>
    import(
      "@/components/financeiro/orcamento-anual/CadastroOrcamentoAnual.vue"
    ),
  "editar.orcamentoanual": () =>
    import("@/components/financeiro/orcamento-anual/EditarOrcamentoAnual.vue"),
  ContaBancariaTransferencias: () =>
    import(
      "@/components/financeiro/conta-bancaria-transferencia/ListagemContaBancariaTransferencia.vue"
    ),
  "cadastro.ContaBancariaTransferencia": () =>
    import(
      "@/components/financeiro/conta-bancaria-transferencia/CadastroContaBancariaTransferencia.vue"
    ),
  "editar.contabancariatransferencia": () =>
    import(
      "@/components/financeiro/conta-bancaria-transferencia/EditarContaBancariaTransferencia.vue"
    ),
  Fornecedores: () =>
    import("@/components/financeiro/fornecedores/ListagemFornecedores.vue"),
  "cadastro.Fornecedor": () =>
    import("@/components/financeiro/fornecedores/CadastroFornecedor.vue"),
  "editar.fornecedor": () =>
    import("@/components/financeiro/fornecedores/EditarFornecedor.vue"),
  TituloReceber: () =>
    import("@/components/financeiro/titulo-receber/ListagemTituloReceber.vue"),
  TituloReceberPending: () =>
    import(
      "@/components/financeiro/titulo-receber/ListagemTituloReceberPending.vue"
    ),
  "cadastro.TituloReceber": () =>
    import("@/components/financeiro/titulo-receber/CadastroTituloReceber.vue"),
  "editar.tituloreceber": () =>
    import("@/components/financeiro/titulo-receber/EditarTituloReceber.vue"),
  RegistroRecebimentos: () =>
    import(
      "@/components/financeiro/registro-recebimentos/ListagemRegistroRecebimentos.vue"
    ),
  "cadastro.RegistroRecebimento": () =>
    import(
      "@/components/financeiro/registro-recebimentos/CadastroRegistroRecebimento.vue"
    ),
  "editar.registrorecebimento": () =>
    import(
      "@/components/financeiro/registro-recebimentos/EditarRegistroRecebimento.vue"
    ),
  TituloPagar: () =>
    import("@/components/financeiro/titulo-pagar/ListagemTituloPagar.vue"),
  TituloPagarPending: () =>
    import(
      "@/components/financeiro/titulo-pagar/ListagemTituloPagarPending.vue"
    ),
  "cadastro.TituloPagar": () =>
    import("@/components/financeiro/titulo-pagar/CadastroTituloPagar.vue"),
  "editar.titulopagar": () =>
    import("@/components/financeiro/titulo-pagar/EditarTituloPagar.vue"),
  RegistroPagamentos: () =>
    import(
      "@/components/financeiro/registro-pagamentos/ListagemRegistroPagamentos.vue"
    ),
  "cadastro.RegistroPagamento": () =>
    import(
      "@/components/financeiro/registro-pagamentos/CadastroRegistroPagamento.vue"
    ),
  "editar.registropagamento": () =>
    import(
      "@/components/financeiro/registro-pagamentos/EditarRegistroPagamento.vue"
    ),
  FinanceiroPeriodo: () =>
    import(
      "@/components/financeiro/financeiro-periodo/ListagemFinanceiroPeriodos.vue"
    ),
  "cadastro.FinanceiroPeriodo": () =>
    import(
      "@/components/financeiro/financeiro-periodo/CadastroFinanceiroPeriodo.vue"
    ),
  "editar.financeiroperiodo": () =>
    import(
      "@/components/financeiro/financeiro-periodo/EditarFinanceiroPeriodo.vue"
    ),
  FuncionarioPontoCalculo: () =>
    import(
      "@/components/pessoal/funcionario-ponto/ListagemFuncionarioPontoCalculo.vue"
    ),
  PessoalGestaoComunicacoes: () =>
    import("@/components/pessoal/gestao-comunicacoes/PessoalGestaoComunicacoes.vue"),
  FuncionarioPontoPeriodo: () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/ListagemFuncionarioPontoPeriodos.vue"
    ),
  TutorialFuncionarioPontoPeriodo: () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/TutorialListagemFuncionarioPontoPeriodos.vue"
    ),
  "cadastro.FuncionarioPontoPeriodo": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/CadastroFuncionarioPontoPeriodo.vue"
    ),
  "editar.funcionariopontoperiodo": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/EditarFuncionarioPontoPeriodo.vue"
    ),
  "tutorial.editar.funcionariopontoperiodo": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo/TutorialEditarFuncionarioPontoPeriodo.vue"
    ),
  FuncionarioPontoPeriodoReducaoCargaHorariaColetiva: () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo-reducao-carga-horaria-coletiva/ListagemFuncionarioPontoPeriodoReducaoCargaHorariaColetiva.vue"
    ),
  FuncionarioPontoNotificacoes: () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-notificacao/ListagemFuncionarioPontoNotificacoes.vue"
    ),
  "cadastro.FuncionarioPontoNotificacao": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-notificacao/CadastroFuncionarioPontoNotificacao.vue"
    ),
  "editar.funcionariopontonotificacao": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-notificacao/EditarFuncionarioPontoNotificacao.vue"
    ),
  "cadastro.FuncionarioPontoPeriodoReducaoCargaHorariaColetiva": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo-reducao-carga-horaria-coletiva/CadastroFuncionarioPontoPeriodoReducaoCargaHorariaColetiva.vue"
    ),
  "editar.funcionariopontoperiodoreducaocargahorariacoletiva": () =>
    import(
      "@/components/pessoal/funcionario-ponto/funcionario-ponto-periodo-reducao-carga-horaria-coletiva/EditarFuncionarioPontoPeriodoReducaoCargaHorariaColetiva.vue"
    ),
  FolgaBonusRegras: () =>
    import("@/components/pessoal/folga-bonus/ListagemFolgaBonusRegras.vue"),
  "cadastro.FolgaBonusRegra": () =>
    import("@/components/pessoal/folga-bonus/CadastroFolgaBonusRegra.vue"),
  "editar.folgabonusregra": () =>
    import("@/components/pessoal/folga-bonus/EditarFolgaBonusRegra.vue"),
  FolgaBonusApuracao: () =>
    import("@/components/pessoal/folga-bonus/ApuracaoFolgaBonus.vue"),
  ParametrizacaoFiscal: () =>
    import(
      "@/components/comercial/parametrizacao-fiscal/ListagemParametrizacaoFiscal.vue"
    ),
  "cadastro.ParametrizacaoFiscal": () =>
    import(
      "@/components/comercial/parametrizacao-fiscal/CadastroParametrizacaoFiscal.vue"
    ),
  "editar.parametrizacaofiscal": () =>
    import(
      "@/components/comercial/parametrizacao-fiscal/EditarParametrizacaoFiscal.vue"
    ),
  Contratos: () =>
    import("@/components/comercial/contratos/ListagemContratos.vue"),
  "cadastro.Contrato": () =>
    import("@/components/comercial/contratos/CadastroContrato.vue"),
  "editar.contrato": () =>
    import("@/components/comercial/contratos/EditarContrato.vue"),
  PropostaComerciais: () =>
    import(
      "@/components/comercial/proposta-comercial/ListagemPropostaComercial.vue"
    ),
  DashboardPropostaComercial: () =>
    import(
      "@/components/comercial/proposta-comercial/DashboardPropostaComercial.vue"
    ),
  "cadastro.PropostaComercial": () =>
    import(
      "@/components/comercial/proposta-comercial/CadastroPropostaComercial.vue"
    ),
  "editar.propostacomercial": () =>
    import(
      "@/components/comercial/proposta-comercial/EditarPropostaComercial.vue"
    ),
  ModeloPropostaComerciais: () =>
    import(
      "@/components/comercial/modelo-proposta-comercial/ListagemModeloPropostaComercial.vue"
    ),
  "cadastro.ModeloPropostaComercial": () =>
    import(
      "@/components/comercial/modelo-proposta-comercial/CadastroModeloPropostaComercial.vue"
    ),
  "editar.modelopropostacomercial": () =>
    import(
      "@/components/comercial/modelo-proposta-comercial/EditarModeloPropostaComercial.vue"
    ),
  D4SignConfiguracao: () =>
    import("@/components/comercial/d4sign-configuracao/D4SignConfiguracao.vue"),
  ConcomitanciasTransporte: () =>
    import(
      "@/components/comercial/concomitancia-transporte/ListagemConcomitanciasTransporte.vue"
    ),
  "cadastro.ConcomitanciaTransporte": () =>
    import(
      "@/components/comercial/concomitancia-transporte/CadastroConcomitanciaTransporte.vue"
    ),
  "editar.concomitanciatransporte": () =>
    import(
      "@/components/comercial/concomitancia-transporte/EditarConcomitanciaTransporte.vue"
    ),
  EscopoServicos: () =>
    import("@/components/comercial/escopo-servicos/ListagemEscopoServicos.vue"),
  "cadastro.EscopoServico": () =>
    import("@/components/comercial/escopo-servicos/CadastroEscopoServico.vue"),
  "editar.escoposervico": () =>
    import("@/components/comercial/escopo-servicos/EditarEscopoServico.vue"),
  ParametrizacaoServicos: () =>
    import(
      "@/components/comercial/parametrizacao-servicos/ListagemParametrizacaoServicos.vue"
    ),
  "cadastro.ParametrizacaoServico": () =>
    import(
      "@/components/comercial/parametrizacao-servicos/CadastroParametrizacaoServico.vue"
    ),
  "editar.parametrizacaoservico": () =>
    import(
      "@/components/comercial/parametrizacao-servicos/EditarParametrizacaoServico.vue"
    ),
  PostoTrabalhos: () =>
    import("@/components/comercial/posto-trabalho/ListagemPostoTrabalhos.vue"),
  "cadastro.PostoTrabalho": () =>
    import("@/components/comercial/posto-trabalho/CadastroPostoTrabalho.vue"),
  "editar.postotrabalho": () =>
    import("@/components/comercial/posto-trabalho/EditarPostoTrabalho.vue"),
  FuncionarioEscalaTrabalhos: () =>
    import(
      "@/components/pessoal/funcionario-escala-trabalho/ListagemFuncionarioEscalaTrabalhos.vue"
    ),
  "cadastro.FuncionarioEscalaTrabalho": () =>
    import(
      "@/components/pessoal/funcionario-escala-trabalho/CadastroFuncionarioEscalaTrabalho.vue"
    ),
  "editar.funcionarioescalatrabalho": () =>
    import(
      "@/components/pessoal/funcionario-escala-trabalho/EditarFuncionarioEscalaTrabalho.vue"
    ),
  ArmaFogos: () =>
    import("@/components/operacoes/arma-fogo/ListagemArmaFogos.vue"),
  ArmaFogoAuditoria: () =>
    import("@/components/operacoes/arma-fogo/ListagemArmaFogoAuditoria.vue"),
  ArmaFogoManutencoes: () =>
    import("@/components/operacoes/arma-fogo/ListagemArmaFogoManutencoes.vue"),
  "cadastro.ArmaFogoManutencao": () =>
    import("@/components/operacoes/arma-fogo/CadastroArmaFogoManutencao.vue"),
  "editar.armafogomanutencao": () =>
    import("@/components/operacoes/arma-fogo/EditarArmaFogoManutencao.vue"),
  "cadastro.ArmaFogo": () =>
    import("@/components/operacoes/arma-fogo/CadastroArmaFogo.vue"),
  "editar.armafogo": () =>
    import("@/components/operacoes/arma-fogo/EditarArmaFogo.vue"),
  ArmaFogoMunicoes: () =>
    import(
      "@/components/operacoes/arma-fogo-municao/ListagemArmaFogoMunicoes.vue"
    ),
  "cadastro.ArmaFogoMunicao": () =>
    import(
      "@/components/operacoes/arma-fogo-municao/CadastroArmaFogoMunicao.vue"
    ),
  "editar.armafogomunicao": () =>
    import(
      "@/components/operacoes/arma-fogo-municao/EditarArmaFogoMunicao.vue"
    ),
  ArmaFogoMunicaoMovimentacoes: () =>
    import(
      "@/components/operacoes/arma-fogo-municao/ListagemArmaFogoMunicaoMovimentacoes.vue"
    ),
  "cadastro.ArmaFogoMunicaoMovimentacao": () =>
    import(
      "@/components/operacoes/arma-fogo-municao/CadastroArmaFogoMunicaoMovimentacao.vue"
    ),
  "editar.armafogomunicaomovimentacao": () =>
    import(
      "@/components/operacoes/arma-fogo-municao/EditarArmaFogoMunicaoMovimentacao.vue"
    ),
  Certidoes: () =>
    import("@/components/comercial/certidoes/ListagemCertidoes.vue"),
  "cadastro.Certidao": () =>
    import("@/components/comercial/certidoes/CadastroCertidao.vue"),
  "editar.certidao": () =>
    import("@/components/comercial/certidoes/EditarCertidao.vue"),
  ColeteBalisticos: () =>
    import(
      "@/components/operacoes/colete-balistico/ListagemColeteBalisticos.vue"
    ),
  "cadastro.ColeteBalistico": () =>
    import(
      "@/components/operacoes/colete-balistico/CadastroColeteBalistico.vue"
    ),
  "editar.coletebalistico": () =>
    import("@/components/operacoes/colete-balistico/EditarColeteBalistico.vue"),
  FuncionarioMovimentacoes: () =>
    import(
      "@/components/pessoal/funcionario-movimentacao/ListagemFuncionarioMovimentacoes.vue"
    ),
  "cadastro.FuncionarioMovimentacoes": () =>
    import(
      "@/components/pessoal/funcionario-movimentacao/CadastroFuncionarioMovimentacao.vue"
    ),
  "editar.funcionariomovimentacoes": () =>
    import(
      "@/components/pessoal/funcionario-movimentacao/EditarFuncionarioMovimentacao.vue"
    ),
  MovimentacaoDiariaOrigemExternas: () =>
    import(
      "@/components/operacoes/movimentacao-diaria-origem-externa/ListagemMovimentacaoDiariaOrigemExterna.vue"
    ),
  "cadastro.MovimentacaoDiariaOrigemExterna": () =>
    import(
      "@/components/operacoes/movimentacao-diaria-origem-externa/CadastroMovimentacaoDiariaOrigemExterna.vue"
    ),
  "editar.movimentacaodiariaorigemexterna": () =>
    import(
      "@/components/operacoes/movimentacao-diaria-origem-externa/EditarMovimentacaoDiariaOrigemExterna.vue"
    ),
  MovimentacaoDiariaMotivoCoberturas: () =>
    import(
      "@/components/operacoes/movimentacao-diaria-motivo-cobertura/ListagemMovimentacaoDiariaMotivoCobertura.vue"
    ),
  "cadastro.MovimentacaoDiariaMotivoCobertura": () =>
    import(
      "@/components/operacoes/movimentacao-diaria-motivo-cobertura/CadastroMovimentacaoDiariaMotivoCobertura.vue"
    ),
  "editar.movimentacaodiariamotivocobertura": () =>
    import(
      "@/components/operacoes/movimentacao-diaria-motivo-cobertura/EditarMovimentacaoDiariaMotivoCobertura.vue"
    ),
  MovimentacaoDiarias: () =>
    import(
      "@/components/operacoes/movimentacao-diaria/ListagemMovimentacaoDiaria.vue"
    ),
  "cadastro.MovimentacaoDiaria": () =>
    import(
      "@/components/operacoes/movimentacao-diaria/CadastroMovimentacaoDiaria.vue"
    ),
  "editar.movimentacaodiaria": () =>
    import(
      "@/components/operacoes/movimentacao-diaria/EditarMovimentacaoDiaria.vue"
    ),
  Cfops: () => import("@/components/comercial/cfop/ListagemCfops.vue"),
  "cadastro.Cfop": () => import("@/components/comercial/cfop/CadastroCfop.vue"),
  "editar.cfop": () => import("@/components/comercial/cfop/EditarCfop.vue"),
  cfopCidades: () =>
    import("@/components/comercial/cfopCidades/ListagemCfopCidades.vue"),
  "cadastro.CfopCidade": () =>
    import("@/components/comercial/cfopCidades/CadastroCfopCidade.vue"),
  "editar.cfopcidade": () =>
    import("@/components/comercial/cfopCidades/EditarCfopCidade.vue"),
  cfopEstados: () =>
    import("@/components/comercial/cfopEstados/ListagemCfopEstados.vue"),
  "cadastro.CfopEstado": () =>
    import("@/components/comercial/cfopEstados/CadastroCfopEstado.vue"),
  "editar.cfopestado": () =>
    import("@/components/comercial/cfopEstados/EditarCfopEstado.vue"),
  "cadastro.EmailMarketing": () =>
    import("@/components/email-marketing/EnviarEmailMarketing.vue"),
  EmailMarketing: () =>
    import("@/components/email-marketing/ListagemEmailMarketing.vue"),
  GraficosPeriodo: () =>
    import(
      "@/components/pessoal/funcionario-ponto/graficos/modelo01/Graficos.vue"
    ),
  GraficosPeriodoMod02: () =>
    import(
      "@/components/pessoal/funcionario-ponto/graficos/modelo01/Graficos.vue"
    ),
  FuncionarioPeriodosAquisitivos: () =>
    import(
      "@/components/pessoal/funcionario-periodo-aquisitivo/ListagemFuncionarioPeriodoAquisitivo.vue"
    ),
  "cadastro.FuncionarioPeriodoAquisitivo": () =>
    import(
      "@/components/pessoal/funcionario-periodo-aquisitivo/CadastroFuncionarioPeriodoAquisitivo.vue"
    ),
  "editar.funcionarioperiodoaquisitivo": () =>
    import(
      "@/components/pessoal/funcionario-periodo-aquisitivo/EditarFuncionarioPeriodoAquisitivo.vue"
    ),
  funcionarioAfastamentos: () =>
    import(
      "@/components/pessoal/funcionario-afastamento/ListagemFuncionarioAfastamentos.vue"
    ),
  "cadastro.FuncionarioAfastamento": () =>
    import(
      "@/components/pessoal/funcionario-afastamento/CadastroFuncionarioAfastamento.vue"
    ),
  "editar.funcionarioafastamento": () =>
    import(
      "@/components/pessoal/funcionario-afastamento/EditarFuncionarioAfastamento.vue"
    ),
  FuncionarioBancoHorasContratos: () =>
    import("@/components/pessoal/banco-de-horas/ListagemBancoHoras.vue"),
  "cadastro.FuncionarioBancoHorasContrato": () =>
    import("@/components/pessoal/banco-de-horas/CadastroBancoHora.vue"),
  "cadastro.FuncionarioBancoHorasContratosSaldo": () =>
    import("@/components/pessoal/banco-de-horas/CadastroBancoHoraSaldo.vue"),
  "editar.funcionariobancohorascontrato": () =>
    import("@/components/pessoal/banco-de-horas/EditarBancoHora.vue"),
  gestaoEfetivo: () =>
    import("@/components/pessoal/gestao-efetivo/ListagemGestaoEfetivo"),
  centroComandoOperacional: () =>
    import("@/components/pessoal/gestao-efetivo/CentroComandoOperacional"),
  gestaoEfetivoAnalise: () =>
    import("@/components/pessoal/gestao-efetivo/DashboardGestaoEfetivoAnalise"),
  PedidoMateriais: () =>
    import("@/components/recursos/pedido-material/ListagemPedidos"),
  "cadastro.PedidoMaterial": () =>
    import("@/components/recursos/pedido-material/CadastroPedido"),
  "editar.pedidomaterial": () =>
    import("@/components/recursos/pedido-material/EditarPedido"),
  PedidoUniformes: () =>
    import("@/components/recursos/pedido-uniforme/ListagemPedidos"),
  PlanejamentoCompraSubstituicaoUniformes: () =>
    import(
      "@/components/recursos/pedido-uniforme/PlanejamentoCompraSubstituicaoUniformes"
    ),
  PlanejamentoCompraUniformes: () =>
    import(
      "@/components/recursos/pedido-uniforme/PlanejamentoCompraSubstituicaoUniformes"
    ),
  UniformeSubstituicao: () =>
    import(
      "@/components/recursos/pedido-uniforme/PlanejamentoCompraSubstituicaoUniformes"
    ),
  "cadastro.PedidoUniforme": () =>
    import("@/components/recursos/pedido-uniforme/CadastroPedido"),
  "editar.pedidouniforme": () =>
    import("@/components/recursos/pedido-uniforme/EditarPedido"),
  PedidoConsumiveis: () =>
    import("@/components/recursos/pedido-consumivel/ListagemPedidos"),
  PedidoConsumiveisProprios: () =>
    import("@/components/recursos/pedido-consumivel-proprio/ListagemPedidos"),
  "cadastro.PedidoConsumivelProprio": () =>
    import("@/components/recursos/pedido-consumivel-proprio/CadastroPedido"),
  "editar.pedidoconsumivelproprio": () =>
    import("@/components/recursos/pedido-consumivel-proprio/EditarPedido"),
  "cadastro.PedidoConsumivel": () =>
    import("@/components/recursos/pedido-consumivel/CadastroPedido"),
  "editar.pedidoconsumivel": () =>
    import("@/components/recursos/pedido-consumivel/EditarPedido"),
  ContaFinanceiras: () =>
    import("@/components/financeiro/conta-financeira/ListagemContaFinanceira"),
  ContaFinanceirasConta: () =>
    import(
      "@/components/financeiro/conta-financeira/ListagemContaFinanceiraConta"
    ),
  ContaFinanceiraNiveis: () =>
    import(
      "@/components/financeiro/conta-financeira-nivel/ListagemContaFinanceiraNivel"
    ),
  "cadastro.ContaFinanceira": () =>
    import("@/components/financeiro/conta-financeira/CadastroContaFinanceira"),
  "editar.contafinanceira": () =>
    import("@/components/financeiro/conta-financeira/EditarContaFinanceira"),
  "cadastro.ContaFinanceiraNivel": () =>
    import(
      "@/components/financeiro/conta-financeira-nivel/CadastroContaFinanceiraNivel"
    ),
  "editar.contafinanceiranivel": () =>
    import(
      "@/components/financeiro/conta-financeira-nivel/EditarContaFinanceiraNivel"
    ),
  Imobilizados: () =>
    import("@/components/recursos/imobilizados/ListagemImobilizado"),
  "cadastro.Imobilizado": () =>
    import("@/components/recursos/imobilizados/CadastroImobilizado"),
  "editar.imobilizado": () =>
    import("@/components/recursos/imobilizados/EditarImobilizado"),
  ImobilizadoMovimentacoes: () =>
    import(
      "@/components/recursos/imobilizado-movimentacoes/ListagemImobilizadoMovimentacao"
    ),
  "cadastro.ImobilizadoMovimentacao": () =>
    import(
      "@/components/recursos/imobilizado-movimentacoes/CadastroImobilizadoMovimentacao"
    ),
  "editar.imobilizadomovimentacao": () =>
    import(
      "@/components/recursos/imobilizado-movimentacoes/EditarImobilizadoMovimentacao"
    ),
  FuncionarioFolhaPagamentoPeriodos: () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento-periodo/ListagemFuncionarioFolhaPagamentoPeriodo"
    ),
  FuncionarioFolhaPagamentos: () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento/ListagemFuncionarioFolhaPagamento"
    ),
  DashboardFolhaPagamento: () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento/DashboardFolhaPagamento"
    ),
  "cadastro.FuncionarioFolhaPagamentoPeriodo": () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento-periodo/CadastroFuncionarioFolhaPagamentoPeriodo"
    ),
  "editar.funcionariofolhapagamentoperiodo": () =>
    import(
      "@/components/pessoal/funcionario-folha-pagamento-periodo/EditarFuncionarioFolhaPagamentoPeriodo"
    ),
  CalculoFaturamento: () =>
    import(
      "@/components/faturamento/calculo-faturamento/ListagemCalculoFaturamento"
    ),
  CurvaABCFaturamento: () =>
    import("@/components/faturamento/RelatorioCurvaABCFaturamento"),
  PracaFiscais: () =>
    import("@/components/faturamento/praca-fiscal/ListagemPracaFiscal"),
  "cadastro.FaturamentoPracaFiscal": () =>
    import("@/components/faturamento/praca-fiscal/CadastroPracaFiscal"),
  "editar.faturamentopracafiscal": () =>
    import("@/components/faturamento/praca-fiscal/EditarPracaFiscal"),
  DocumentoFiscal: () =>
    import("@/components/faturamento/documento-fiscal/ListagemDocumentoFiscal"),
  "cadastro.faturamentodocumentofiscal": () =>
    import("@/components/faturamento/documento-fiscal/CadastroDocumentoFiscal"),
  "editar.faturamentodocumentofiscal": () =>
    import("@/components/faturamento/documento-fiscal/EditarDocumentoFiscal"),
  FaturamentoPeriodo: () =>
    import(
      "@/components/faturamento/faturamento-periodo/ListagemFaturamentoPeriodos"
    ),
  "cadastro.FaturamentoPeriodo": () =>
    import(
      "@/components/faturamento/faturamento-periodo/CadastroFaturamentoPeriodo"
    ),
  "editar.faturamentoperiodo": () =>
    import(
      "@/components/faturamento/faturamento-periodo/EditarFaturamentoPeriodo"
    ),
  BeneficioConvenios: () =>
    import("@/components/pessoal/beneficio/convenio/ListagemBeneficioConvenio"),
  "cadastro.BeneficioConvenio": () =>
    import("@/components/pessoal/beneficio/convenio/CadastroBeneficioConvenio"),
  "editar.beneficioconvenio": () =>
    import("@/components/pessoal/beneficio/convenio/EditarBeneficioConvenio"),
  BeneficioConvenioOptantes: () =>
    import(
      "@/components/pessoal/beneficio/optante/ListagemBeneficioConvenioOptante"
    ),
  "cadastro.BeneficioConvenioOptante": () =>
    import(
      "@/components/pessoal/beneficio/optante/CadastroBeneficioConvenioOptante"
    ),
  "editar.beneficioconveniooptante": () =>
    import(
      "@/components/pessoal/beneficio/optante/EditarBeneficioConvenioOptante"
    ),
  BeneficioPeriodoApuracoes: () =>
    import(
      "@/components/pessoal/beneficio/periodo/ListagemBeneficioPeriodoApuracao"
    ),
  "cadastro.BeneficioPeriodoApuracao": () =>
    import(
      "@/components/pessoal/beneficio/periodo/CadastroBeneficioPeriodoApuracao"
    ),
  "editar.beneficioperiodoapuracao": () =>
    import(
      "@/components/pessoal/beneficio/periodo/EditarBeneficioPeriodoApuracao"
    ),
  BeneficioApuracao: () =>
    import("@/components/pessoal/beneficio/calculo/ListagemBeneficioApuracao"),
  usuarioPerfis: () => import("@/components/acessos/perfis/ListagemPerfil"),
  "cadastro.UsuarioPerfil": () =>
    import("@/components/acessos/perfis/CadastroPerfil"),
  "editar.usuarioperfil": () =>
    import("@/components/acessos/perfis/EditarPerfil"),
  permissoes: () => import("@/components/acessos/permissoes/ListagemPermissao"),
  "cadastro.Permissao": () =>
    import("@/components/acessos/permissoes/CadastroPermissao"),
  "editar.permissao": () =>
    import("@/components/acessos/permissoes/EditarPermissao"),
  "beneficio.analise.cliente": () =>
    import("@/components/pessoal/beneficio/analise-cliente/Realizado"),
  "beneficio.direitos.dashboard": () =>
    import(
      "@/components/pessoal/beneficio/dashboard-direitos/DashboardDireitosBeneficio"
    ),
  MetodoCobrancas: () =>
    import("@/components/comercial/metodo-cobranca/ListagemMetodoCobranca"),
  "cadastro.MetodoCobranca": () =>
    import("@/components/comercial/metodo-cobranca/CadastroMetodoCobranca"),
  "editar.metodocobranca": () =>
    import("@/components/comercial/metodo-cobranca/EditarMetodoCobranca"),
  CompraPedidos: () =>
    import("@/components/recursos/compras/compra-pedido/ListagemCompraPedido"),
  "cadastro.CompraPedido": () =>
    import("@/components/recursos/compras/compra-pedido/CadastroCompraPedido"),
  "editar.comprapedido": () =>
    import("@/components/recursos/compras/compra-pedido/EditarCompraPedido"),

  CompraOrcamentos: () =>
    import(
      "@/components/recursos/compras/compra-orcamento/ListagemCompraOrcamento"
    ),
  "cadastro.CompraOrcamento": () =>
    import(
      "@/components/recursos/compras/compra-orcamento/CadastroCompraOrcamento"
    ),
  "editar.compraorcamento": () =>
    import(
      "@/components/recursos/compras/compra-orcamento/EditarCompraOrcamento"
    ),

  CaixaForte: () =>
    import("@/components/operacoes/caixaForte/ListagemCaixaForte"),
  "cadastro.CaixaForte": () =>
    import("@/components/operacoes/caixaForte/CadastroCaixaForte"),
  "editar.caixaforte": () =>
    import("@/components/operacoes/caixaForte/EditarCaixaForte"),
  ImobilizadoMovimentacaoConsulta: () =>
    import(
      "@/components/recursos/imobilizado-movimentacoes/ListagemImobilizadoMovimentacaoConsulta"
    ),
  CaixaForteFechamento: () =>
    import("@/components/operacoes/caixaForte/ListagemCaixaForteFechamento"),
  "cadastro.CaixaForteFechamento": () =>
    import("@/components/operacoes/caixaForte/CadastroCaixaForteFechamento"),
  "editar.caixafortefechamento": () =>
    import("@/components/operacoes/caixaForte/EditarCaixaForteFechamento"),

  CaixaForteItem: () =>
    import("@/components/operacoes/transporte/ListagemCaixaForteItem"),
  RelatorioGuiasRotaSemEntrada: () =>
    import(
      "@/components/operacoes/caixaForte/RelatorioEntradasPendentesCaixaForte"
    ),
  CaixaForteEntradasPendentes: () =>
    import(
      "@/components/operacoes/caixaForte/RelatorioEntradasPendentesCaixaForte"
    ),
  CaixaForteAuditoria: () =>
    import("@/components/operacoes/caixaForte/ListagemCaixaForteAuditoria"),
  CaixaForteSaldo: () =>
    import("@/components/operacoes/caixaForte/AcompanhamentoCaixaForteSaldo"),
  TransporteChaves: () =>
    import("@/components/operacoes/transporte-chave/ListagemTransporteChaves"),
  TransporteChaveAuditoria: () =>
    import(
      "@/components/operacoes/transporte-chave/ListagemTransporteChaveAuditoria"
    ),
  "cadastro.TransporteChave": () =>
    import("@/components/operacoes/transporte-chave/CadastroTransporteChave"),
  "editar.transportechave": () =>
    import("@/components/operacoes/transporte-chave/EditarTransporteChave"),
  TransporteChaveMovimentacoes: () =>
    import(
      "@/components/operacoes/transporte-chave-movimentacao/ListagemTransporteChaveMovimentacoes"
    ),
  TransporteChaveMovimentacoesConsulta: () =>
    import(
      "@/components/operacoes/transporte-chave-movimentacao/ListagemTransporteChaveMovimentacoesConsulta"
    ),
  ArmaFogoColeteBalisticoMovimentacoes: () =>
    import(
      "@/components/operacoes/movimentacao-arma-fogo-colete-balistico/ListagemArmaFogoColeteBalisticoMovimentacoes"
    ),
  ArmaFogoColeteBalisticoMovimentacoesConsulta: () =>
    import(
      "@/components/operacoes/movimentacao-arma-fogo-colete-balistico/ListagemArmaFogoColeteBalisticoMovimentacoesConsulta"
    ),
  "cadastro.CaixaForteItem": () =>
    import("@/components/operacoes/transporte/CadastroCaixaForteItem"),
  "editar.caixaforteitem": () =>
    import("@/components/operacoes/transporte/EditarCaixaForteItem"),
  TesourariaArea: () =>
    import("@/components/operacoes/tesouraria/ListagemTesourariaArea"),
  "cadastro.TesourariaArea": () =>
    import("@/components/operacoes/tesouraria/CadastroTesourariaArea"),
  "editar.tesourariaarea": () =>
    import("@/components/operacoes/tesouraria/EditarTesourariaArea"),
  Tesouraria: () =>
    import("@/components/operacoes/tesouraria/ListagemTesouraria"),
  "cadastro.Tesouraria": () =>
    import("@/components/operacoes/tesouraria/CadastroTesouraria"),
  "editar.tesouraria": () =>
    import("@/components/operacoes/tesouraria/EditarTesouraria"),
  OperacaoMoeda: () =>
    import("@/components/operacoes/tesouraria/ListagemOperacaoMoeda"),
  "cadastro.OperacaoMoeda": () =>
    import("@/components/operacoes/tesouraria/CadastroOperacaoMoeda"),
  "editar.operacaomoeda": () =>
    import("@/components/operacoes/tesouraria/EditarOperacaoMoeda"),
  OperacaoMoedaCotacao: () =>
    import("@/components/operacoes/tesouraria/ListagemOperacaoMoedaCotacao"),
  "cadastro.OperacaoMoedaCotacao": () =>
    import("@/components/operacoes/tesouraria/CadastroOperacaoMoedaCotacao"),
  "editar.operacaomoedacotacao": () =>
    import("@/components/operacoes/tesouraria/EditarOperacaoMoedaCotacao"),
  TesourariaSaidasConfirmacaoPendente: () =>
    import(
      "@/components/operacoes/tesouraria/RelatorioSaidasConfirmacaoPendenteTesouraria"
    ),
  TesourariaMovimentacao: () =>
    import("@/components/operacoes/tesouraria/ListagemTesourariaMovimentacao"),
  "cadastro.TesourariaMovimentacao": () =>
    import("@/components/operacoes/tesouraria/CadastroTesourariaMovimentacao"),
  TesourariaTurno: () =>
    import("@/components/operacoes/tesouraria/ListagemTesourariaTurno"),
  "cadastro.TesourariaTurno": () =>
    import("@/components/operacoes/tesouraria/CadastroTesourariaTurno"),
  "editar.tesourariaturno": () =>
    import("@/components/operacoes/tesouraria/EditarTesourariaTurno"),
  TesourariaDiferencaTipos: () =>
    import("@/components/operacoes/tesouraria/ListagemTesourariaDiferencaTipo"),
  "cadastro.TesourariaDiferencaTipo": () =>
    import("@/components/operacoes/tesouraria/CadastroTesourariaDiferencaTipo"),
  "editar.tesourariadiferencatipo": () =>
    import("@/components/operacoes/tesouraria/EditarTesourariaDiferencaTipo"),
  TesourariaRecontagem: () =>
    import("@/components/operacoes/tesouraria/OperacaoTesourariaRecontagem"),
  TesourariaSaldo: () =>
    import("@/components/operacoes/tesouraria/DashboardTesourariaSaldo"),
  TesourariaPosicao: () =>
    import("@/components/operacoes/tesouraria/RelatorioPosicaoTesouraria"),
  TesourariaProdutividade: () =>
    import(
      "@/components/operacoes/tesouraria/DashboardTesourariaProdutividade"
    ),
  TesourariaRecontagemBancada: () =>
    import(
      "@/components/operacoes/tesouraria/DashboardTesourariaRecontagemBancada"
    ),

  CompraOrdens: () =>
    import("@/components/recursos/compras/compra-ordem/ListagemCompraOrdem"),
  ComprasEmissoesCnpj: () =>
    import(
      "@/components/recursos/compras/compras-emissoes-cnpj/ListagemComprasEmissoesCnpj"
    ),
  SolicitacaoCompras: () =>
    import(
      "@/components/recursos/compras/solicitacao-compra/ListagemSolicitacaoCompra"
    ),
  "cadastro.SolicitacaoCompra": () =>
    import(
      "@/components/recursos/compras/solicitacao-compra/CadastroSolicitacaoCompra"
    ),
  "editar.solicitacaocompra": () =>
    import(
      "@/components/recursos/compras/solicitacao-compra/EditarSolicitacaoCompra"
    ),
  "cadastro.Feriado": () =>
    import("@/components/software/feriados/CadastroFeriado"),
  "editar.feriado": () =>
    import("@/components/software/feriados/EditarFeriado"),
  Feriados: () => import("@/components/software/feriados/ListagemFeriados"),
  faturamentovariaveisservicos: () =>
    import(
      "@/components/faturamento/variaveis-servico/ListagemVariaveisServico"
    ),
  "cadastro.FaturamentoVariaveisServico": () =>
    import(
      "@/components/faturamento/variaveis-servico/CadastroVariaveisServico"
    ),
  "editar.faturamentovariaveisservico": () =>
    import("@/components/faturamento/variaveis-servico/EditarVariaveisServico"),
  registrotarefaperiodo: () =>
    import("@/components/operacoes/tarefas/periodo/ListagemTarefasPeriodos"),
  "cadastro.RegistroTarefaPeriodo": () =>
    import("@/components/operacoes/tarefas/periodo/CadastroTarefasPeriodo"),
  "editar.registrotarefaperiodo": () =>
    import("@/components/operacoes/tarefas/periodo/EditarTarefasPeriodo"),
  RegistroTarefaCalculo: () =>
    import(
      "@/components/operacoes/tarefas/calculo/ListagemRegistrosTarefaApuracao"
    ),
  lancamentosContabeis: () =>
    import("@/components/contabilidade/LancamentoContabil"),
  AvisoPrevio: () =>
    import("@/components/pessoal/funcionario-aviso-previo/ListagemAvisoPrevio"),
  "cadastro.FuncionarioAvisoPrevio": () =>
    import("@/components/pessoal/funcionario-aviso-previo/CadastroAvisoPrevio"),
  "editar.funcionarioavisoprevio": () =>
    import("@/components/pessoal/funcionario-aviso-previo/EditarAvisoPrevio"),
  ModeloDocumentacaoAcessoria: () =>
    import(
      "@/components/pessoal/modelo-documentacao-acessoria/ListagemModeloDocumentacaoAcessoria"
    ),
  "cadastro.ModeloDocumentacaoAcessoria": () =>
    import(
      "@/components/pessoal/modelo-documentacao-acessoria/CadastroModeloDocumentacaoAcessoria"
    ),
  "editar.modelodocumentacaoacessoria": () =>
    import(
      "@/components/pessoal/modelo-documentacao-acessoria/EditarModeloDocumentacaoAcessoria"
    ),
  OrcamentoDespesa: () =>
    import(
      "@/components/financeiro/orcamento-despesa/ListagemOrcamentoDespesa"
    ),
  DashboardOrcamentoDespesa: () =>
    import(
      "@/components/financeiro/orcamento-despesa/DashboardOrcamentoDespesa"
    ),
  funcionarioAfastamentoSolicitacao: () =>
    import(
      "@/components/pessoal/funcionario-afastamento-solicitacao/ListagemFuncionarioAfastamentoSolicitacao"
    ),
  "cadastro.FuncionarioAfastamentoSolicitacao": () =>
    import(
      "@/components/pessoal/funcionario-afastamento-solicitacao/CadastroFuncionarioAfastamentoSolicitacao"
    ),
  importarHorarios: () =>
    import(
      "@/components/pessoal/funcionario-escala-trabalho/GestaoAcademicaHorarios"
    ),
  ContaVinculadaMovimentacoes: () =>
    import(
      "@/components/financeiro/conta-vinculada-movimentacao/ListagemContaVinculadaMovimentacao"
    ),
  "cadastro.ContaVinculadaMovimentacao": () =>
    import(
      "@/components/financeiro/conta-vinculada-movimentacao/CadastroContaVinculadaMovimentacao"
    ),
  "editar.contavinculadamovimentacao": () =>
    import(
      "@/components/financeiro/conta-vinculada-movimentacao/EditarContaVinculadaMovimentacao"
    ),
  "cadastro.Equipamento": () =>
    import("@/components/operacoes/equipamentos/CadastroEquipamento"),
  "editar.equipamento": () =>
    import("@/components/operacoes/equipamentos/EditarEquipamento"),
  CentroDepositos: () =>
    import("@/components/operacoes/centro-deposito/ListagemCentroDeposito.vue"),
  "cadastro.CentroDeposito": () =>
    import("@/components/operacoes/centro-deposito/CadastroCentroDeposito.vue"),
  "editar.centrodeposito": () =>
    import("@/components/operacoes/centro-deposito/EditarCentroDeposito.vue"),
  AnaliseMovimentacaoCentroDeposito: () =>
    import(
      "@/components/operacoes/equipamentos/AnaliseMovimentacaoCentroDeposito.vue"
    ),
  "cadastro.CodigoIdentificacaoReciproca": () =>
    import(
      "@/components/operacoes/codigoIdentificacaoReciproca/CadastroCodigoIdentificacaoReciproca"
    ),
  "editar.codigoidentificacaoreciproca": () =>
    import(
      "@/components/operacoes/codigoIdentificacaoReciproca/EditarCodigoIdentificacaoReciproca"
    ),
  "cadastro.LogisticaTipoEvento": () =>
    import(
      "@/components/operacoes/logisticaTipoEvento/CadastroLogisticaTipoEvento"
    ),
  "editar.logisticatipoevento": () =>
    import(
      "@/components/operacoes/logisticaTipoEvento/EditarLogisticaTipoEvento"
    ),
  "cadastro.LogisticaTipoOcorrencia": () =>
    import(
      "@/components/operacoes/logisticaTipoOcorrencia/CadastroLogisticaTipoOcorrencia"
    ),
  "editar.logisticatipoocorrencia": () =>
    import(
      "@/components/operacoes/logisticaTipoOcorrencia/EditarLogisticaTipoOcorrencia"
    ),
  "cadastro.DebitoSimplificado": () =>
    import(
      "@/components/financeiro/debito-simplificado/CadastroDebitoSimplificado.vue"
    ),
  "cadastro.CreditoSimplificado": () =>
    import(
      "@/components/financeiro/credito-simplificado/CadastroCreditoSimplificado.vue"
    ),
  "cadastro.CentroEstoque": () =>
    import("@/components/recursos/centro-estoque/CadastroCentroEstoque"),
  "editar.centroestoque": () =>
    import("@/components/recursos/centro-estoque/EditarCentroEstoque"),
  "editar.produtocentroestoque": () =>
    import("@/components/recursos/produtos/EditarProdutoCentroEstoque"),
  "cadastro.PedidoConsumivelCentroEstoque": () =>
    import(
      "@/components/recursos/pedido-consumivel-centro-estoque/CadastroPedido"
    ),
  "cadastro.AssistenciaTecnicaTipo": () =>
    import(
      "@/components/operacoes/assistenciaTecnicaTipo/CadastroAssistenciaTecnicaTipo"
    ),
  "editar.assistenciatecnicatipo": () =>
    import(
      "@/components/operacoes/assistenciaTecnicaTipo/EditarAssistenciaTecnicaTipo"
    ),
  "cadastro.ReajusteContratual": () =>
    import(
      "@/components/comercial/reajusteContratual/CadastroReajusteContratual.vue"
    ),
  "cadastro.RoteirizadorParametro": () =>
    import(
      "@/components/operacoes/roteirizadorParametro/CadastroRoteirizadorParametro"
    ),
  "editar.roteirizadorparametro": () =>
    import(
      "@/components/operacoes/roteirizadorParametro/EditarRoteirizadorParametro"
    ),
  "cadastro.ImobilizadoClassificacao": () =>
    import(
      "@/components/recursos/imobilizado-classificacao/CadastroImobilizadoClassificacao"
    ),
  "editar.imobilizadoclassificacao": () =>
    import(
      "@/components/recursos/imobilizado-classificacao/EditarImobilizadoClassificacao"
    ),

  "cadastro.TarefaClassificacao": () =>
    import(
      "@/components/operacoes/tarefa-classificacao/CadastroTarefaClassificacao"
    ),
  "editar.tarefaclassificacao": () =>
    import(
      "@/components/operacoes/tarefa-classificacao/EditarTarefaClassificacao"
    ),
  TarefaClassificacaoAgrupamento: () =>
    import(
      "@/components/operacoes/tarefa-classificacao-agrupamento/ListagemTarefaClassificacaoAgrupamento"
    ),
  "cadastro.TarefaClassificacaoAgrupamento": () =>
    import(
      "@/components/operacoes/tarefa-classificacao-agrupamento/CadastroTarefaClassificacaoAgrupamento"
    ),
  "editar.tarefaclassificacaoagrupamento": () =>
    import(
      "@/components/operacoes/tarefa-classificacao-agrupamento/EditarTarefaClassificacaoAgrupamento"
    ),
  "cadastro.TarefaSolicitacao": () =>
    import(
      "@/components/operacoes/tarefa-solicitacao/CadastroTarefaSolicitacao"
    ),
  "editar.tarefasolicitacao": () =>
    import("@/components/operacoes/tarefa-solicitacao/EditarTarefaSolicitacao"),

  "cadastro.TarefaExecucao": () =>
    import("@/components/operacoes/tarefa-execucao/CadastroTarefaExecucao"),
  "editar.tarefaexecucao": () =>
    import("@/components/operacoes/tarefa-execucao/EditarTarefaExecucao"),

  "cadastro.TarefaExecucaoItem": () =>
    import(
      "@/components/operacoes/tarefa-execucao-item/CadastroTarefaExecucaoItem"
    ),
  "editar.tarefaexecucaoitem": () =>
    import(
      "@/components/operacoes/tarefa-execucao-item/EditarTarefaExecucaoItem"
    ),

  "cadastro.PostoTrabalhoOcorrencia": () =>
    import(
      "@/components/comercial/posto-trabalho-ocorrencias/CadastroPostoTrabalhoOcorrencia"
    ),
  "editar.postotrabalhoocorrencia": () =>
    import(
      "@/components/comercial/posto-trabalho-ocorrencias/EditarPostoTrabalhoOcorrencia"
    ),

  "cadastro.RegistradorPontoExterno": () =>
    import(
      "@/components/pessoal/registrador-ponto-externo/CadastroRegistradorPontoExterno"
    ),
  "editar.registradorpontoexterno": () =>
    import(
      "@/components/pessoal/registrador-ponto-externo/EditarRegistradorPontoExterno"
    ),
  "cadastro.PontoFacultativo": () =>
    import("@/components/software/pontosFacultativo/CadastroPontoFacultativo"),
  "editar.pontofacultativo": () =>
    import("@/components/software/pontosFacultativo/EditarPontoFacultativo"),

  "cadastro.FaturamentoProdutoTransporte": () =>
    import(
      "@/components/faturamento/produto-transporte/CadastroProdutoTransporte"
    ),
  "editar.faturamentoprodutotransporte": () =>
    import(
      "@/components/faturamento/produto-transporte/EditarProdutoTransporte"
    ),

  "cadastro.ComunicacaoInterna": () =>
    import(
      "@/components/pessoal/comunicacao-interna/CadastroComunicacaoInterna"
    ),
  "editar.comunicacaointerna": () =>
    import("@/components/pessoal/comunicacao-interna/EditarComunicacaoInterna"),

  "cadastro.FuncionarioRegistrador": () =>
    import(
      "@/components/pessoal/funcionario-registrador/CadastroFuncionarioRegistrador"
    ),
  "editar.funcionarioregistrador": () =>
    import(
      "@/components/pessoal/funcionario-registrador/EditarFuncionarioRegistrador"
    ),
  "cadastro.FuncionarioPontoWeb": () =>
    import(
      "@/components/pessoal/funcionario-ponto-web/CadastroFuncionarioPontoWeb"
    ),
  "editar.funcionariopontoweb": () =>
    import(
      "@/components/pessoal/funcionario-ponto-web/EditarFuncionarioPontoWeb"
    ),

  "editar.funcionariopontosolicitacao": () =>
    import(
      "@/components/pessoal/funcionario-ponto-solicitacao/EditarFuncionarioPontoSolicitacao"
    ),
  "cadastro.FuncionarioPontoSolicitacao": () =>
    import(
      "@/components/pessoal/funcionario-ponto-solicitacao/CadastroFuncionarioPontoSolicitacao"
    ),
  FuncionarioPreContratracaoDocumentos: () =>
    import(
      "@/components/pessoal/funcionario-pre-contratacao-documentos/ListagemFuncionarioPreContratracaoDocumentos.vue"
    ),
  "cadastro.FuncionarioPreContratracaoDocumentos": () =>
    import(
      "@/components/pessoal/funcionario-pre-contratacao-documentos/CadastroFuncionarioPreContratracaoDocumentos.vue"
    ),
  "editar.funcionarioprecontratracaodocumentos": () =>
    import(
      "@/components/pessoal/funcionario-pre-contratacao-documentos/EditarFuncionarioPreContratracaoDocumentos.vue"
    ),
  GestaoContratacao: () =>
    import("@/components/pessoal/gestao-contratacao/GestaoContratacao.vue"),
  GestaoContratacaoDashboard: () =>
    import(
      "@/components/pessoal/gestao-contratacao/GestaoContratacaoDashboard.vue"
    ),
  RecrutamentoBancoTalentos: () =>
    import("@/components/pessoal/gestao-contratacao/BancoTalentos.vue"),
  RecrutamentoDashboardEntrevistas: () =>
    import(
      "@/components/pessoal/gestao-contratacao/DashboardEntrevistas.vue"
    ),
  RecrutamentoDashboardBancoTalentos: () =>
    import(
      "@/components/pessoal/gestao-contratacao/DashboardBancoTalentos.vue"
    ),
  RecrutamentoSolicitacao: () =>
    import(
      "@/components/pessoal/gestao-contratacao/solicitacoes/ListagemRecrutamentoSolicitacao.vue"
    ),
  "cadastro.RecrutamentoSolicitacao": () =>
    import(
      "@/components/pessoal/gestao-contratacao/solicitacoes/CadastroRecrutamentoSolicitacao.vue"
    ),
  "editar.recrutamentosolicitacao": () =>
    import(
      "@/components/pessoal/gestao-contratacao/solicitacoes/EditarRecrutamentoSolicitacao.vue"
    ),
  FuncionarioPreContratracao: () =>
    import(
      "@/components/pessoal/funcionario-pre-contratacao/ListagemFuncionarioPreContratracao.vue"
    ),
  "cadastro.FuncionarioPreContratracao": () =>
    import(
      "@/components/pessoal/funcionario-pre-contratacao/CadastroFuncionarioPreContratracao.vue"
    ),
  "editar.funcionarioprecontratracao": () =>
    import(
      "@/components/pessoal/funcionario-pre-contratacao/EditarFuncionarioPreContratracao.vue"
    ),
  LogAuditoria: () =>
    import("@/components/software/log-auditoria/ListagemLogAuditoria.vue"),
  "editar.logtransacao": () =>
    import("@/components/software/log-auditoria/EditarLogTransacao.vue"),
  OperacoesPendentesTransacoes: () =>
    import(
      "@/components/software/operacoes-pendentes-transacoes/ListagemOperacaoPendenteTransacao.vue"
    ),
  "editar.operacaopendentetransacao": () =>
    import(
      "@/components/software/operacoes-pendentes-transacoes/EditarOperacaoPendenteTransacao.vue"
    ),
  FaceDescriptors: () =>
    import(
      "@/components/software/face-descriptors/ListagemFaceDescriptors.vue"
    ),
  "cadastro.FaceDescriptor": () =>
    import("@/components/software/face-descriptors/CadastroFaceDescriptor.vue"),
  "editar.facedescriptor": () =>
    import("@/components/software/face-descriptors/EditarFaceDescriptor.vue"),
};
